var _ellipse, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondarySmall = function SvgSecondarySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 188 189"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94,
    cy: 94.318,
    fill: "#F07D00",
    rx: 94,
    ry: 94.318
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.789,
    cy: 85.789,
    r: 84.289,
    stroke: "#ABB6BD",
    strokeDasharray: "1 10",
    strokeWidth: 3,
    transform: "matrix(.70591 .7083 -.70591 .7083 94 -27.211)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.789,
    cy: 85.789,
    r: 81.789,
    stroke: "#ABB6BD",
    strokeDasharray: "1 60",
    strokeWidth: 8,
    transform: "matrix(.70591 .7083 -.70591 .7083 94 -27.211)"
  })));
};
export default SvgSecondarySmall;